export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.template': 'Template',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  // Talent Management
  'menu.talents': 'Talents',
  'menu.talents.allTalents': 'All Talents',
  'menu.talents.myTalents': 'My Talents',
  'menu.talents.privateTalents': 'My Private Pool',
  'menu.talents.publicTalents': 'Public Pool',
  'menu.talents.talentCollection': 'Collection',
  'menu.talents.__talentCollectionAction': 'Talent Collection',
  'menu.talents.createTalent': 'Create Talent',
  'menu.talents.editTalent': 'Edit Talent',
  'menu.talents.talentDetail': 'Talent Detail',
  'menu.talents.talentTests': 'Talent Tests',
  'menu.talent-create': 'Create Talent',
  'menu.talent-detail': 'Talent Detail',
  'menu.talent-test-create': 'Create Test',
  // Job Management
  'menu.jobs': 'Jobs',
  'menu.jobs.allJobs': 'All Jobs',
  'menu.jobs.myJobs': 'My Jobs',
  'menu.jobs.createJob': 'Create Job',
  'menu.jobs.editJob': 'Edit Job',
  'menu.jobs.jobDetail': 'Job Detail',
  // Client Management
  'menu.clients': 'Clients',
  'menu.clients.allClients': 'All Clients',
  'menu.clients.myClients': 'My Clients',
  'menu.clients.privateClients': 'My Private Pool',
  'menu.clients.publicClients': 'Public Pool',
  'menu.clients.clientCollection': 'Collection',
  'menu.clients.__clientCollectionAction': 'Client Collection',
  'menu.clients.createClient': 'Create Client',
  'menu.clients.editClient': 'Edit Client',
  'menu.clients.clientDetail': 'Client Detail',
  // Team Management
  'menu.teamManagement': 'Team Management',
  'menu.teamManagement.consultantPrivatePools': 'Consultant Private Pools',
  // Project Management
  'menu.projects': 'Projects',
  'menu.projects.allProjects': 'All Projects',
  'menu.projects.myProjects': 'My Projects',
  'menu.projects.recommendedProjects': 'Recommended Projects',
  'menu.projects.responsibleProjects': 'Responsible Projects',
  'menu.projects.projectCollection': 'Collection Projects',
  'menu.projects.__projectCollectionAction': 'Project Collection',
  'menu.projects.createProject': 'Create Project',
  'menu.projects.editProject': 'Edit Project',
  'menu.projects.projectDetail': 'Project Detail',
  // Interview Management
  'menu.interviews': 'Interviews',
  'menu.interviews.allInterviews': 'All Interviews',
  'menu.interviews.myInterviews': 'My Interviews',
  'menu.interviews.interviewsList': 'Interviews List',
  'menu.interviews.interviewsList.all': 'All Interviews',
  'menu.interviews.interviewsList.my': 'My Interviews',
  'menu.interviews.interviewExecution': 'Interview Execution',
  // Reports
  'menu.reports': 'Reports',
  'menu.reports.performanceReports': 'Performance Statistics',
  'menu.reports.businessReports': 'Business Statistics',
  // Work Reports
  'menu.workReports': 'Work Reports',
  'menu.workReports.dailyReports': 'Daily Reports',
  'menu.workReports.dailyReports.dailyReportsAll': 'All Daily Reports',
  'menu.workReports.dailyReports.dailyReportToday': "Today's Report",
  'menu.workReports.weeklyReports': 'Weekly Reports',
  'menu.workReports.weeklyReports.weeklyReportsAll': 'All Weekly Reports',
  'menu.workReports.weeklyReports.weeklyReportThisWeek': "This Week's Report",
  'menu.workReports.monthlyReports': 'Monthly Reports',
  'menu.workReports.monthlyReports.monthlyReportsAll': 'All Monthly Reports',
  'menu.workReports.monthlyReports.monthlyReportThisMonth':
    "This Month's Report",
  'menu.workReports.yearlyReports': 'Yearly Reports',
  'menu.workReports.yearlyReports.yearlyReportsAll': 'All Yearly Reports',
  'menu.workReports.yearlyReports.yearlyReportThisYear': "This Year's Report",
  'menu.generate-recommendation-report': 'Generate Recommendation Report',
  // Analytics
  'menu.analytics': 'Analytics',
  'menu.analytics.analyticsOverview': 'Overview Analytics',
  'menu.analytics.analyticsClients': 'Client Analytics',
  'menu.analytics.analyticsProjects': 'Project Analytics',
  'menu.analytics.analyticsTalents': 'Talent Analytics',
  'menu.analytics.analyticsWork': 'Work Analytics',
  'menu.analytics.analyticsJobs': 'Job Analytics',
  'menu.lightHunter': 'Light Hunter',
  'menu.lightHunter.lightHunterDashboard': 'Workbench',
  'menu.lightHunter.lightHunterEnterprises': 'Enterprise Management',
  'menu.lightHunter.lightHunterEnterprises.lightHunterEnterpriseRelease':
    'Enterprise Release',
  'menu.lightHunter.lightHunterEnterprises.lightHunterEnterpriseFollow':
    'Enterprise Follow-up',
  'menu.lightHunter.lightHunterEnterprises.lightHunterEnterpriseJobs':
    'Job Postings',
  'menu.lightHunter.lightHunterTalents': 'Talent Pool',
  'menu.lightHunter.lightHunterTasks': 'Task Center',
  'menu.lightHunter.lightHunterRecommendations': 'Recommendations',
  'menu.lightHunter.lightHunterCandidates': 'Candidates',
  'menu.lightHunter.lightHunterTaskDetail': 'Task Detail',
  'menu.lightHunter.lightHunterChat': 'Messages',
  'menu.lightHunter.lightHunterMembers': 'Members & Verification',
  'menu.lightHunter.lightHunterMembers.lightHunterMemberUsers': 'Members',
  'menu.lightHunter.lightHunterMembers.lightHunterHunterDirectory':
    'Hunter Directory',
  'menu.lightHunter.lightHunterMembers.lightHunterHunterDetail':
    'Hunter Detail',
  'menu.lightHunter.lightHunterMembers.lightHunterBusinessTeams':
    'Business Teams',
  'menu.lightHunter.lightHunterMembers.lightHunterRealNameVerifications':
    'Real-name Verification',
  'menu.lightHunter.lightHunterAnalytics': 'Data Analysis',
  'menu.lightHunter.lightHunterVerifications': 'Verification Review',
  'menu.lightHunter.lightHunterFinance': 'Settlement & Withdrawals',
  'menu.lightHunter.lightHunterPoints': 'Points',
  'menu.lightHunter.lightHunterRewardRules': 'Reward Rules',
  'menu.lightHunter.lightHunterWithdrawals': 'Withdrawals',
  // Personal Settings
  'menu.settings': 'Settings',
  'menu.settings.settingsProfile': 'Profile',
  'menu.settings.settingsReportTemplates': 'Report Templates',
  'menu.settings.settingsMessages': 'Messages',
  // Content Management
  'menu.content': 'Content',
  'menu.articles': 'Articles',
  'menu.articles.allArticles': 'All Articles',
  'menu.articles.articleDetail': 'Article Detail',
  'menu.topics': 'Topics',
  'menu.topic-detail': 'Topic Detail',
  'menu.questions': 'Questions',
  'menu.questions.allQuestions': 'All Questions',
  'menu.questions.myQuestions': 'My Questions',
  'menu.questions.myAnswers': 'My Answers',
  'menu.questions.questionDetail': 'Question Detail',
  'menu.questions.questionCategories': 'Categories',
  // System
  'menu.data-dictionaries': 'Data Dictionaries',
  'menu.dataDictionaries': 'Data Dictionaries',
  'menu.companies': 'Companies',
  // Others
  'menu.feed': 'Feed',
  'menu.notifications': 'Notifications',
  'menu.search': 'Search',
  'menu.interview-execution': 'Interview Execution',
  'menu.my-answers': 'My Answers',
  'menu.personal-settings-messages': 'Message Settings',
  'menu.personal-settings-report-templates': 'Report Templates',
  'menu.generateRecommendationReport': 'Generate Recommendation Report',
  // Dynamic menu actions (legacy compatibility)
  'menu.__talentCollectionAction': 'Talent Collection',
  'menu.__clientCollectionAction': 'Client Collection',
  'menu.__projectCollectionAction': 'Project Collection',
};
